import { get } from '../tools/http';

export default {
    namespaced: true,

    state: () => ({
        news: [],
        concreteNews: undefined,
        currentPage: 0,
        perPage: 6,
        pagesCount: 0,
        filters: [],
        currentFilter: {},
        loading: false,
        hashTag: '',
    }),

    mutations: {
        updateHashTag: (state, tag) => state.hashTag = tag,
        writeItems: (state, news) => state.news = news,
        writeCurrentItem: (state, news) => state.concreteNews = news,
        setPagesCount: (state, count) => state.pagesCount = count,
        writeFilters: (state, filters) => state.filters = filters,
        setCurrentFilter: (state, filters) => state.currentFilter = filters,
        setLoading: (state, loading) => state.loading = loading,
        setCurrentPage (state, page) {
            if (page >= 1) {
                state.currentPage = page;
            }
        },
    },

    actions: {
        loadFilters: async () => { },

        setHashTag: (ctx, { tag }) => {
            ctx.commit('updateHashTag', tag);
            ctx.dispatch('loadItems', { page: 0 });
        },

        loadItems: async (ctx, { page = null, showFirst = false }) => {
            if (page !== null) {
                ctx.commit('setCurrentPage', page);
            }

            const offset = ctx.state.perPage * (ctx.state.currentPage - 1);
            const limit = ctx.state.perPage;

            let sort = 'sort[0][column]=createdAt&sort[0][order]=DESC';
            let tags = ctx.state.hashTag ? `hashtag=${ctx.state.hashTag}` : "";
            let q = `limit=${limit}&offset=${offset}&isPublic=true&${tags}&${sort}`;

            (await get(
                'cms',
                `entity/config`
            ));


            const data = (await get(
                'cms',
                `entity/select/news?${q}`
            ));
            let news = data.list;

            if (news.length === 0 && ctx.state.currentPage > 1) {
                ctx.commit('setCurrentPage', 1);
                return;
            }

            const pagesCount = Math.ceil(data.count / limit);
            if (pagesCount > 0) {
                ctx.commit('setPagesCount', pagesCount);
            }
            ctx.commit('writeItems', news);

            if (showFirst) {
                ctx.commit('writeCurrentItem', news[0]);
            }
            return data;
        },

        loadItem: async (ctx, id) => {
            if (ctx.state.concreteNews
                && parseInt(ctx.state.concreteNews.id) === parseInt(id)) {
                return;
            }

            // ctx.commit('writeCurrentItem', null);
            const data = await get(
                'cms',
                `entity/select/news?id=${id}`,
            );

            if (data.list.length > 0) {
                ctx.commit('writeCurrentItem', data.list[0]);
            } else {
                ctx.commit('writeCurrentItem', null);
            }
            return data;
        },
    },

    getters: {
        top4news: state => state.news.slice(0, 4),
        allItems: state => state.news.slice(0),
        currentItem: state => state.concreteNews,
        currentPage: state => state.currentPage,
        pagesCount: state => state.pagesCount,
        filtersList: state => state.filters.slice(0),
        filterQuery: state => state.currentFilter,
        isLoading: state => state.loading,
        getHashTag: state => state.hashTag,
    },
};
